import { render, staticRenderFns } from "./AgricultureComponent.vue?vue&type=template&id=3eb2e28c"
import script from "./AgricultureComponent.vue?vue&type=script&lang=js"
export * from "./AgricultureComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports